export { default } from './ConstructorSlider';
